// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"774":"AutoElementChart","924":"StoChartsLineChart"}[chunkId] || chunkId) + ".chunk.js";
};